import { useEffect, useState } from "react";
import { apiGet } from "./api";
import { Login } from "./pages/Login";
import { Setup } from "./pages/Setup";
import { AppShell } from "./components/Shell";
import { PrefsProvider } from "./lib/prefs";
import { useLocation } from "./lib/router";
import { matchRoute } from "./lib/route-match";
import { Overview } from "./pages/Overview";
import { AppDetail } from "./pages/AppDetail";
import { Usage } from "./pages/Usage";
import { Customers } from "./pages/Customers";
import { Inbox } from "./pages/Inbox";
import { Settings } from "./pages/Settings";
import { EmptyState } from "./components/ui";
import { Link } from "./lib/router";
import { CliLogin } from "./pages/CliLogin";

type Auth = "loading" | "in" | "out";

export function App() {
  return (
    <PrefsProvider>
      <Root />
    </PrefsProvider>
  );
}

function Root() {
  const [auth, setAuth] = useState<Auth>("loading");
  const path = window.location.pathname;

  useEffect(() => {
    let alive = true;
    apiGet("/api/auth/session")
      .then((r) => (alive ? setAuth(r.ok ? "in" : "out") : null))
      .catch(() => (alive ? setAuth("out") : null));
    return () => {
      alive = false;
    };
  }, []);

  if (path === "/setup") return <Setup />;
  if (path === "/cli-login") return <CliLogin auth={auth} />;

  if (auth === "loading") {
    return (
      <div className="auth-screen">
        <div className="glass-card">
          <div className="logo-wrap">
            <div className="spinner" style={{ borderTopColor: "var(--accent)", borderColor: "rgba(10,132,255,.25)" }} />
          </div>
        </div>
      </div>
    );
  }
  return auth === "in" ? (
    <AppShell>
      <Routes />
    </AppShell>
  ) : (
    <Login />
  );
}

function Routes() {
  const { path } = useLocation();
  let m: Record<string, string> | null;
  if (path === "/") return <Overview />;
  if ((m = matchRoute("/apps/:id", path))) return <AppDetail id={m.id as string} key={m.id} />;
  if (path === "/gebruik") return <Usage />;
  if (path === "/klanten") return <Customers appUserId={null} />;
  if ((m = matchRoute("/klanten/:appUserId", path))) return <Customers appUserId={m.appUserId as string} />;
  if (path === "/inbox") return <Inbox />;
  if (path === "/instellingen") return <Settings />;
  return (
    <div className="card">
      <EmptyState title="Pagina niet gevonden">
        <Link to="/" className="link">
          Terug naar het overzicht
        </Link>
      </EmptyState>
    </div>
  );
}
